import { useCallback } from "react";

import { viewModelToInput } from "./converter";
import { useSiteControllerSettingBeds24Mutation } from "../../repository/mutation";

import type { SiteControllerSettingBeds24FormModel } from "../../type";

type Props = {
	viewModel: SiteControllerSettingBeds24FormModel["ViewModel"];
};

export const useUpdateSiteControllerSettingBeds = ({ viewModel }: Props) => {
	const { onUpdate: _onUpdate } = useSiteControllerSettingBeds24Mutation();
	const onUpdate = useCallback(async () => {
		const input = viewModelToInput({ viewModel });
		return await _onUpdate({ input });
	}, [_onUpdate, viewModel]);

	return {
		onUpdate,
	};
};
